module.exports = __webpack_public_path__ + "assets/img/btn-view-8c10e3a8.png";